/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { normalizeVariantUpdateData } from './helpers/normalizeVariantUpdateData';
import { updateListingVariantInState } from './helpers/channelHelpers';
import { formatProductUpdateErrorMessage } from './helpers/formatProductUpdateErrorMessage';

export const updateListingVariant = createAsyncThunk(
  'products/updateListingVariant',
  async ({
    listingProductId, listingVariantId, masterProductId, channelId, data,
  }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const normalizedData = normalizeVariantUpdateData(data);
      const { data: updatedVariant } = await sdk.products.updateVariant(
        listingProductId,
        listingVariantId,
        normalizedData,
      );
      return { masterProductId, channelId, data: updatedVariant };
    } catch (error) {
      const rawMessage = utils.getDataFromResponceError(error, 'msg');
      const errorMessage = rawMessage
        ? formatProductUpdateErrorMessage(rawMessage)
        : 'Cannot update listing variant';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error updating listing variant'), { error }, [
        'UpdateListingVariantFailed',
        { errorMessage: rawMessage || errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(updateListingVariant.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(updateListingVariant.fulfilled, (state, { payload }) => {
      state.isBusy = false;
      updateListingVariantInState(state, payload);
    })
    .addCase(updateListingVariant.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot update listing variant';
    });
};
